import AppRecord from './AppRecord.js'

class PersonFamily extends AppRecord {
  get controller_name(){
    return 'PersonFamiliesController'
  }
}
export default PersonFamily
